export default __webpack_public_path__ + "static/media/logo_lideres.93f7bd29.png";